// extracted by css-extract-rspack-plugin
module.exports =  {"primaryPanelHeader":"SocialInsurances__primaryPanelHeader--kV2a_"};